import React from 'react';
import { useTranslation } from 'react-i18next';
import PublishButton from '../../../../../common/components/PublishButton';
import Form from '../../common/components/Form';
import CancelButton from '../../common/components/CancelButtonLink';
import FormBottomActionsContainer from '../../common/components/FormBottomActionsContainer';

const SubmitRequestStep = ({ onCancel, onStepCompleted, isSaving }) => {
  const { t } = useTranslation();
  return (
    <Form
      onSubmit={onStepCompleted}
      data-testid="project-create-form"
      className="step-3-form"
    >
      <h2>{t('settingUpProject')}</h2>
      <p>{t('ProjectSettingMessage')}</p>
      <br />
      <div className="separator" />
      <FormBottomActionsContainer>
        <CancelButton onClick={onCancel} dataTestId="cancel-button" />
        <PublishButton
          isSaving={isSaving}
          isValid
          buttonSize="sm"
          onSaveText="Submitting..."
          standbyText={t('createProjectBtn')}
          dataTestId="create-project-button"
        />
      </FormBottomActionsContainer>
    </Form>
  );
};

export default SubmitRequestStep;
